






























import Component, { mixins } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { UserReferring } from "@scrile/api-provider/dist/api/UserReferringProvider";
import WithAuthUser from "@/mixins/WithAuthUser";
import WithSystemSettings from "@/mixins/WithSystemSettings";
import { $t } from "@/lib/i18nHelpers";
import { getAbsUrl, shareUrl } from "@/lib/urlHelpers";
import BaseButton from "@/components/BaseButton";
import BasePage from "@/components/BasePage";
import PageTitle from "@/components/PageTitle";
import ReferralsList from "@/views/PageReferrals/components/ReferralsList.vue";

@Component({ name: "ReferralsView", components: { ReferralsList, BasePage, PageTitle, BaseButton } })
export default class ReferralsView extends mixins(WithAuthUser, WithSystemSettings) {
  @Prop({ type: Boolean, required: true })
  public readonly loading!: boolean;

  @Prop({ type: Boolean, required: true })
  public readonly enableScroll!: boolean;

  @Prop({ type: Array, required: true })
  public readonly userReferrings!: UserReferring[];

  @Prop({ type: Number, required: true })
  public readonly userReferrerPercent!: number;

  public shareClick() {
    return shareUrl(getAbsUrl(`/signup/?referral=${this.authUserStrict.id}`), $t("Link copied to clipboard"));
  }

  public async created() {
    await this.systemSettingsGetData();
  }
}
